module.exports = __webpack_public_path__ + "static/media/Piercing-ear-antitragus.6dd80b5c.png";